import { render, staticRenderFns } from "./DadosPeriodoFinanceiro.vue?vue&type=template&id=04fa73e0&"
import script from "./DadosPeriodoFinanceiro.vue?vue&type=script&lang=js&"
export * from "./DadosPeriodoFinanceiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports